export const ACCOUNT_BUTTON_LABEL = 'Next';

export const ACCOUNT_FORM_TITLE = 'Create your account.';
export const EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'aol.com',
  'yahoo.com',
];
